import SimplePagination from './Pagination.vue'
import { Button, Icon } from 'ant-design-vue'
import './index.less'

/* istanbul ignore next */
SimplePagination.install = function (Vue) {
  Vue.component(SimplePagination.name, SimplePagination)
  Vue.use(Button)
  Vue.use(Icon)
}

export default SimplePagination
